import React, { useState, useRef, MutableRefObject } from 'react';
import { Video } from '@zola/zola-ui/src/assets/images/icons';

import WebsiteVideoUploadModal from 'components/manage/website/WebsiteVideoUploadModal';

import {
  Container,
  Title,
  Label,
  NoEntityContainer,
  VideoIcon,
  StyledButton,
} from './WebsiteVideoUpload.styles';

type WebsiteVideoUploadProps = {
  label: string;
  page: 'home' | 'gallery';
};

const WebsiteVideoUpload = ({ label, page }: WebsiteVideoUploadProps): JSX.Element => {
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalId, setEditModalId] = useState<number | undefined>(undefined);
  const [triggeringRef, setTriggeringRef] = useState<MutableRefObject<null> | null>(null);
  const addTriggerRef = useRef(null);

  const handleToggleModal = () => {
    if (modalOpen) {
      if (editModalId) setEditModalId(undefined);
      setTriggeringRef(null);
    }
    setModalOpen(!modalOpen);
  };

  const openAddOrEditEntityModal = (ref: MutableRefObject<null>, entityId?: number) => {
    handleToggleModal();
    setTriggeringRef(ref);
    if (entityId) setEditModalId(entityId);
  };

  return (
    <Container>
      <Title>Video</Title>
      <NoEntityContainer>
        <VideoIcon src={Video} alt="" />
        <Label>{label}</Label>
        <StyledButton
          variant="secondary"
          onClick={() => openAddOrEditEntityModal(addTriggerRef)}
          innerRef={addTriggerRef}
        >
          Add a Video
        </StyledButton>
      </NoEntityContainer>
      {modalOpen && (
        <WebsiteVideoUploadModal
          onClose={handleToggleModal}
          triggerRef={triggeringRef}
          page={page}
        />
      )}
    </Container>
  );
};

export default WebsiteVideoUpload;
